import { render, staticRenderFns } from "./Fruit.vue?vue&type=template&id=055821d6&scoped=true&"
import script from "./Fruit.vue?vue&type=script&lang=js&"
export * from "./Fruit.vue?vue&type=script&lang=js&"
import style0 from "./Fruit.vue?vue&type=style&index=0&id=055821d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055821d6",
  null
  
)

export default component.exports